import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, ButtonGroup, Checkbox, Divider, Image, useDisclosure } from '@chakra-ui/react';
import iconWarning from 'assets/icons/icon-message-warning.svg';
import React, { useEffect } from 'react';

type ButtonProps = {
  title: string,
  href?: () => void
}

type Props = {
  title?: string,
  description?: string,
  button?: ButtonProps,
  defaultIsOpen: boolean
}

export default function CreateEmailDialog({ title, description, button, defaultIsOpen = false }: Props) {
  const { isOpen, onOpen, onClose } = useDisclosure({ defaultIsOpen });
  useEffect(() => {
    if (defaultIsOpen) {
      onOpen();
    }
  }, [defaultIsOpen, onOpen]);

  const cancelRef = React.useRef();

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isOpen={isOpen}
      isCentered
    >
      <AlertDialogOverlay />

      <AlertDialogContent>
        <AlertDialogHeader
          display="flex"
          flexDir="column"
          alignItems="center"
        >
          <Image src={iconWarning} mb="16px" />
            Prossiga com atenção!
        </AlertDialogHeader>

        <AlertDialogBody textAlign="center" mt="12px">
          Esse disparo será enviado imediatamente para 83 clientes divididos em 3 listas diferentes. Assegure que os dados estão corretos.
        </AlertDialogBody>

        <Divider />

        <AlertDialogFooter 
          justifyContent="space-between"
        >
          <Checkbox> Oculte esse alerta</Checkbox>
          <ButtonGroup>
            <Button 
              ref={cancelRef} 
              size="sm" 
              onClick={onClose}
            >
              Cancelar
            </Button>

            <Button 
              variant="primary" 
              size="sm" 
            >
              Enviar
            </Button>
          </ButtonGroup>

        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}